import { Component, ElementRef, Renderer2, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Platform, ToastController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { MenuService } from './services/menu.service';
import { ThemeService } from './services/theme.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Zoom } from '@ionic-native/zoom/ngx';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { MessagesService } from './services/messages.service';
import { AuthService } from './services/auth.service';
import { PagesService } from './services/pages.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public menuItems: any;
  public themeItems: any;
  public themeList: any;
  public appPages: any;
  public unlinkedPages: any;
  public siteProps: any;
  public sideBarTitle: string;
  public baseUrl: string;
  public logo: string;
  public dashboardPages: any;
  public apiKey: string;
  // Dynamic parameters for this component's route: /example-params/:first/:second
  public routeParams: Params;
  public pageId: any;

  // Query parameters found in the URL: /example-params/one/two?query1=one&query2=two
  public queryParams: Params;
  SDK_KEY = 'gycPK5iW83gLKv3ei2mx3mKcrIYzSuDoHGgs';
  SDK_SECRET = '3VkzRy38fJAw7zq5gyfw7D4F8Ly5HJeXQhVE';

  //auth
  private uid: string;
  message: any;
  name: string;


  constructor(
    public el: ElementRef,
    public renderer: Renderer2,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private menuService: MenuService,
    public themeService: ThemeService,
    public fontLibrary: FaIconLibrary,
    private toastCtrl: ToastController,
    private zoomService: Zoom,
    private messageService: MessagesService,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public pageService: PagesService
  ) {
    this.initializeApp();
    this.getRouteParams();
  }

  initializeApp() {
    this.fontLibrary.addIconPacks(fas);
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      if (this.platform.is('ios') || this.platform.is('android') || this.platform.is('desktop')) {
        this.appPages = [];
      } else {
        this.appPages = [];
      }

      // if (this.platform.is('ios') || this.platform.is('android')) {
      //   this.zoomService.initialize(this.SDK_KEY, this.SDK_SECRET)
      //   .then((success) => {
      //     console.log(success);
      //     this.presentToast(success);
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //     if (this.platform.is('desktop')) {
      //       this.presentToast(error);
      //     }
      //   });
      // }

      this.themeService.getSitePropsApi().subscribe( data => {
        let siteList = [];
        siteList = Object.values(data);

        this.sideBarTitle = data[0].sidebar_title;
        this.baseUrl = data[0].base_url;
        this.apiKey = data[0].APIKey;
        // localStorage.setItem('APIKey', this.siteProps[0].APIKey);
        localStorage.setItem('baseUrl', this.baseUrl);
      });

      this.themeService.getThemeList().once('value', snapshot => {
        this.themeList = [];
        if (localStorage.getItem('baseUrl')) {
          this.logo = localStorage.getItem('baseUrl');
        }
        snapshot.forEach(snap => {
          if (snap.val().state === '1') {
            this.themeList.push({
              primaryColor: snap.val().primary_color,
              secondaryColor: snap.val().secondary_color,
              tertiaryColor: snap.val().tertiary_color,
              backgroundImage: this.baseUrl + snap.val().background_image,
              logo: this.baseUrl + snap.val().logo,
              opacity: snap.val().opacity,
              titleBarBackground: snap.val().title_bar_background,
              titleBarFontColor: snap.val().title_bar_font_color,
              pageBackgroundImage: this.baseUrl + snap.val().page_background_image,
              pageFontColor: snap.val().page_font_color,
              pageSettings: snap.val().page_settings,
              advancedSettings: snap.val().advanced_settings
            });
          }
        });
        this.logo = this.themeList[0].logo;
        localStorage.setItem('logo', this.logo);
        localStorage.setItem('themeList', JSON.stringify(this.themeList));
      });

      this.menuService.getPages().once('value', pageListSnapshot => {
        this.unlinkedPages = [];
        pageListSnapshot.forEach(snap => {
          if (snap.val().menutype === 'mobile-hidden' && snap.val().published === 1) {
            this.unlinkedPages.push({
              title: snap.val().title,
              note: snap.val().note,
              published: snap.val().published,
              url: '/page/' + snap.val().alias,
              featured: snap.val().featured,
              menutype: snap.val().menutype,
              id: snap.val().id,
              parent_id: snap.val().parent_id,
              level: snap.val().level,
              icon: snap.val().note
            });
            return false;
          }
        });

        pageListSnapshot.forEach(snap => {
          if (snap.val().menutype === 'mobilemenu' && snap.val().published === 1) {
            this.appPages.push({
              title: snap.val().title,
              note: snap.val().note,
              published: snap.val().published,
              url: '/page/' + getMenuID(snap.val().link),
              featured: snap.val().featured,
              menutype: snap.val().menutype,
              id: snap.val().id,
              parent_id: snap.val().parent_id,
              level: snap.val().level,
              icon: snap.val().note
            });
            return false;
          }
        });

        function getMenuID(link) {
          const linkParts = link.split('&');
          for (let i = 0; i < linkParts.length; i++) {
            const articleIdKey = linkParts[i].match(/id/g);
            if (articleIdKey) {
              const articleId = linkParts[i].split('=');
              return articleId[1];
            }
          }
        }
      });

      // if (this.platform.is('ios') || this.platform.is('android') || this.platform.is('desktop')) {
      // } else {
      //   console.log('platform is desktop');
      // }
    });
  }

  ngOnInit() {
    
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.uid = user.uid;
        this.messageService.getMessage().on('value', messageSnapshot => {
          this.message = [];
          messageSnapshot.forEach(snap => {
            if (snap.val().active === 'true') {
              this.message.push({
                title: snap.val().title,
                message: snap.val().message,
                date: snap.val().date,
                messageType: snap.val().message_type,
                user: snap.val().user
              });
            }
          });
        });
        
        this.authService.getUserProfile(this.uid).on('value', snapshot => {
          if (snapshot.val() != null) {
            this.name = snapshot.val().name;
            localStorage.setItem('name', this.name);
          }
        });

        this.pageService.getPage('dashboard').on('value', snapshot => {
          const pageId = snapshot.val().id;
          this.router.navigate(['page/' + pageId, {pagetype: 'dashboard'}]);
        });
      } else {
        this.router.navigateByUrl('sign-in');
      }
    });
  }

  getDashboard(alias) {
    this.pageService.getPage(alias).on('value', snapshot => {
      return snapshot.val().id;
    });
  }

  getRouteParams() {

    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });
  }

  async presentToast(text) {
    const toast = await this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
}
